import React, { useMemo } from "react"
import "./index.scss"
import { useSelector } from "react-redux"
import { DateTime } from "luxon"
import Table from "react-bootstrap/Table"

export default function LogTable({ log, viewType = "task", searchTerm = "" }) {
  const timeZone = useSelector((state) => state.teamInfo.timezone)

  // Ensure we don't mutate the redux state and handle non-array log values
  const sortedLogs = useMemo(() => {
    const logs = Array.isArray(log) ? [...log].sort((a, b) => new Date(b.editTime) - new Date(a.editTime)) : []

    // Filter by sample name if in sample view and search term exists
    if (viewType === "sample" && searchTerm) {
      return logs.filter((entry) => {
        const sampleName = entry.sampleName || entry.name || ""
        return sampleName.toLowerCase().includes(searchTerm.toLowerCase())
      })
    }

    return logs
  }, [log, viewType, searchTerm]);

  const formatDateTime = (dateString) => {
    if (!dateString) return "Date Unavailable";
    const dt = DateTime.fromISO(dateString, { zone: 'utc' }).setZone(timeZone);
    return dt.isValid ? dt.toFormat("d. MMM HH.mm") : "Invalid Date";
  };

  function capitalizeFirstLetter(string) {
    if (!string) return ""
    return String(string).charAt(0).toUpperCase() + String(string).slice(1).toLowerCase();
  }

  return (
    <Table bordered hover className="log-table">
      <thead>
        <tr>
          <th>Edited</th>
          {viewType === "instrument" ? (
            <>
              <th>Old Instrument</th>
              <th>New Instrument</th>
              <th>Task Name</th>
              <th>Moved By</th>
              <th>Old Start</th>
              <th>New Start</th>
            </>
          ) : viewType === "sample" ? (
            <>
              <th>Sample Name</th>
              <th>Sample ID</th>
              <th>Analysis Name</th>
              <th>Moved By</th>
              <th>Moved From</th>
              <th>Moved To</th>
              <th>Old Start</th>
              <th>New Start</th>
              <th>Type</th>
            </>
          ) : (
            <>
              <th>Moved by</th>
              <th>Name</th>
              <th>Moved From</th>
              <th>Moved To</th>
              <th>Old Start</th>
              <th>New Start</th>
              <th>Task Name</th>
              <th>Type</th>
            </>
          )}
        </tr>
      </thead>
      <tbody>
        {viewType === "instrument" ? (
          sortedLogs.map((entry, index) => (
            <tr key={index}>
              <td className="log-table-time-column">{formatDateTime(entry.editTime)}</td>
              <td className="log-table-instrument">{entry.oldInstrument || "None"}</td>
              <td className="log-table-instrument">{entry.newInstrument || "None"}</td>
              <td className="log-table-task-name">{entry.taskName}</td>
              <td>{entry.movedByMember}</td>
              <td className="log-table-time-column">{entry.oldStart ? formatDateTime(entry.oldStart) : "Unplanned"}</td>
              <td className="log-table-time-column">{entry.newStart ? formatDateTime(entry.newStart) : "Unplanned"}</td>
            </tr>
          ))
        ) : viewType === "sample" ? (
          sortedLogs.map((entry, index) => (
            <tr key={index}>
              <td className="log-table-time-column">{formatDateTime(entry.editTime)}</td>
              <td className="log-table-name">{entry.sampleName || entry.name}</td>
              <td>{entry.sampleId}</td>
              <td>{entry.analysisName || entry.oldAnalysis || entry.newAnalysis || "N/A"}</td>
              <td>{entry.movedByMember}</td>
              <td>{entry.movedFrom ? entry.movedFrom : "Unplanned"}</td>
              <td>{entry.movedTo ? entry.movedTo : "Unplanned"}</td>
              <td className="log-table-time-column">{entry.oldStart ? formatDateTime(entry.oldStart) : "Unplanned"}</td>
              <td className="log-table-time-column">{entry.newStart ? formatDateTime(entry.newStart) : "Unplanned"}</td>
              <td>{capitalizeFirstLetter(entry.type)}</td>
            </tr>
          ))
        ) : (
          sortedLogs.map((entry, index) => (
            <tr key={index}>
              <td className="log-table-time-column">{formatDateTime(entry.editTime)}</td>
              <td>{entry.movedByMember}</td>
              <td className="log-table-name">{entry.name}</td>
              <td>{entry.oldMember ? entry.oldMember : "Unplanned"}</td>
              <td>{entry.newMember ? entry.newMember : "Unplanned"}</td>
              <td className="log-table-time-column">{entry.oldStart ? formatDateTime(entry.oldStart) : "Unplanned"}</td>
              <td className="log-table-time-column">{entry.newStart ? formatDateTime(entry.newStart) : "Unplanned"}</td>
              <td className="log-table-task-name">{entry.taskName}</td>
              <td>{capitalizeFirstLetter(entry.type)}</td>
            </tr>
          ))
        )}
      </tbody>
    </Table>
  );
}
